import { useEffect, useState } from "react";
import { bitrateServerNow, type BitrateClockAnchor } from "../utils/bitrateHistory";

export function useBitrateClock(anchor: BitrateClockAnchor | undefined): number | null {
  const [, tick] = useState(0);
  useEffect(() => {
    const update = () => tick((value) => value + 1);
    const timer = window.setInterval(update, 1000);
    document.addEventListener("visibilitychange", update);
    return () => {
      window.clearInterval(timer);
      document.removeEventListener("visibilitychange", update);
    };
  }, []);
  return bitrateServerNow(anchor, performance.now());
}
